module.exports = {
	"de": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Seite nicht gefunden",
				"title": "Nicht gefunden",
				"details": "Die gesuchte Anwendung wurde nicht gefunden. Sind Sie sicher, dass Sie die Adresse richtig eingegeben haben?",
				"goBack": "Zurück"
			},
			"activation": {
				"pageTitle": "Sicherheitszone",
				"title": "Willkommen in der Sicherheitszone",
				"activate": {
					"details": "Einen Augenblick, wir bereiten Ihren Aktivierungs-Link vor ...",
					"ready": "Ihr Link steht bereit, klicken Sie auf die Schaltfläche, um fortzufahren. Achtung: Dieser Link kann nur einmal verwendet werden!",
					"go": "Konto aktivieren"
				},
				"passwordReset": {
					"details": "Einen Augenblick, wir bereiten den Link zum Zurücksetzen Ihres Passworts vor ...",
					"ready": "Ihr Link steht bereit, klicken Sie auf die Schaltfläche, um fortzufahren. Achtung: Dieser Link kann nur einmal verwendet werden!",
					"go": "Passwort zurücksetzen"
				},
				"error": {
					"details": "Mit Ihrem Link scheint etwas nicht in Ordnung zu sein. Versuchen Sie es bitte erneut oder wenden Sie sich unter Erwähnung des Codes an den Kundendienst."
				}
			},
			"privacy-policy": {
				"pageTitle": "Datenschutzrichtlinie für das Händlerportal"
			},
			"terms-and-conditions": {
				"pageTitle": "Händlerportal-Vereinbarung"
			},
			"Support": {
				"pageTitle": "Support",
				"topic": {
					"orders": "Bestellungen",
					"settlements": "Abrechnungen",
					"agreements": "Vereinbarungen",
					"technical_issues": "Technische Störungen",
					"others": "Sonstige"
				},
				"TicketList": {
					"title": "Support-Anfragen",
					"pageDescription": "Hier können Sie den Status Ihrer Support-Anfragen einsehen",
					"status": {
						"open": "Öffnen",
						"pending": "Ausstehend",
						"resolved": "Gelöst",
						"closed": "Geschlossen",
						"inProgress": "In Bearbeitung",
						"waitingForYourReply": "Warten auf Ihre Antwort"
					},
					"TicketTable": {
						"id": "Anfrage Nr. ",
						"mid": "Shop/MID",
						"subject": "Betreff",
						"status": "Status",
						"updatedAt": "Aktualisiert am"
					}
				},
				"EmptyTicketList": {
					"title": "Sie haben keine offenen Anfragen"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Benutzer"
						},
						"details": {
							"title": "Details",
							"store": "Shop/MID",
							"createdAt": "Datum der Anfrage",
							"updatedAt": "Aktualisiert am"
						},
						"actions": {
							"close": "Anfrage schließen",
							"reopen": "Anfrage wieder eröffnen"
						},
						"closeTicketDialog": {
							"confirm": "Bestätigen",
							"title": "Anfrage schließen",
							"description": "Sie sind dabei, diese Anfrage zu schließen. Sie können sie ausschließlich in den nächsten 7 Tagen wieder eröffnen.",
							"error": "Hoppla! Da ist etwas schief gelaufen. Versuchen Sie es bitte erneut."
						},
						"reopenTicketDialog": {
							"title": "Anfrage wieder eröffnen",
							"description": "Erläutern Sie, warum Sie diese Anfrage wieder eröffnen möchten, und wir setzen uns baldmöglichst mit Ihnen in Verbindung.",
							"messageLabel": "Nachricht"
						}
					},
					"conversation": {
						"loadMore": "Mehr laden",
						"title": "Anfrage",
						"attachments": {
							"label": "Anlagen"
						},
						"reply": {
							"title": "Kommentar hinzufügen",
							"body": {
								"label": "Einen Kommentar hinzufügen",
								"error": null
							},
							"attachment": {
								"label": "Anlagen hinzufügen",
								"error": "Die Gesamtgröße der Dateien darf nicht über 15 MB liegen."
							},
							"add": "Kommentar hinzufügen",
							"cancel": "Abbrechen",
							"submit": {
								"label": "Abschicken",
								"error": "Beim Speichern des Kommentars ist ein Fehler aufgetreten. Versuchen Sie es bitte später erneut."
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Upps!",
						"message": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es in ein paar Minuten erneut oder kontaktieren Sie uns, sollte das Problem weiterhin bestehen.",
						"contact": "Wenn Sie den Händler-Support kontaktieren, verwenden Sie bitte folgende Correlation ID:",
						"action": "Kontakt"
					},
					"error": "Fehler",
					"default": {
						"title": "Hoppla! Da ist etwas schiefgelaufen",
						"message": "Aus irgendeinem Grund, konnten wir Ihre Anfrage auf unserer Seite nicht ausführen. Sie können es erneut versuchen oder später wiederkommen.",
						"contact": "Wenn Sie den Händler-Support kontaktieren, verwenden Sie bitte folgende Correlation ID:",
						"action": "Aktualisieren"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab and Go Marketing",
				"banner": {
					"title": "Willkommen bei Grab and Go Marketing",
					"subtitle": "Hier finden Sie fertige Assets für Ihre Website, E-Mail-Kampagnen und Social Media Marketing.",
					"button": "Mehr erfahren"
				},
				"productSection": {
					"title": "Welches Klarna Produkt bieten Sie Käufern an?"
				},
				"MarketSelector": {
					"label": "Markt auswählen",
					"markets": {
						"BE": "Belgien (Niederländisch)",
						"BE-FR": "Belgien (Französisch)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 Raten",
						"pin30": "In 30 Tagen bezahlen"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Brauchen Sie Hilfe?",
					"copyButton": "In Zwischenablage kopieren",
					"copyButtonSuccess": "Kopiert!",
					"sourceButton": "Quelle",
					"previewButton": "Vorschau"
				},
				"EmailTemplates": {
					"pageTitle": "E-Mail-Vorlagen",
					"title": "E-Mail-Vorlagen"
				},
				"EmailHeader": {
					"pageTitle": "E-Mail-Marketing Bild",
					"title": "E-Mail-Marketing Bild"
				},
				"Social": {
					"pageTitle": "Soziale Medien",
					"title": "Soziale Medien"
				},
				"buttonDownload": "Bild herunterladen",
				"buttonCopy": "Text kopieren",
				"buttonCopySuccess": "Kopiert!",
				"missingPreview": "Vorschau fehlt",
				"productLinkText": "Material erhalten",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "Eine vollständige Checkout-Lösung, bei der alles an einem Ort ist."
						},
						"payNow": {
							"title": "Sofort bezahlen",
							"subtitle": "Lassen Sie Kunden ihre Bestellungen an einem Ort bezahlen."
						},
						"threeInstallments": {
							"title": "3 Raten",
							"subtitle": "Geben Sie Kunden dir Freiheit, Kosten ohne Zinsen über einen Zeitraum aufzuteilen."
						},
						"fourInstallments": {
							"title": "4 Raten",
							"subtitle": "Geben Sie Kunden dir Freiheit, Kosten ohne Zinsen über einen Zeitraum aufzuteilen."
						},
						"pin14": {
							"title": "Rechnung",
							"subtitle": "In 14 Tagen bezahlen. Keine Zinsen oder zusätzlichen Gebühren."
						},
						"pin21": {
							"title": "In 21 Tagen bezahlen",
							"subtitle": "In 21 Tagen bezahlen. Keine Zinsen oder zusätzlichen Gebühren."
						},
						"pin30": {
							"title": "In 30 Tagen bezahlen",
							"subtitle": "In 30 Tagen bezahlen. Keine Zinsen oder zusätzlichen Gebühren."
						},
						"financing": {
							"title": "Ratenkauf",
							"subtitle": "Steigern Sie Ihren Umsatz, indem Sie Kunden eine Zahlungsfrist von bis zu 36 Monaten anbieten."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Weihnachten 2020",
							"channels": {
								"emailHeader": {
									"title": "E-Mail-Marketing Bild",
									"subtitle": "Wecken Sie zu den Weihnachtsfeiertagen die Aufmerksamlkeit Ihrer Abonnenten mit Bildern in Studioqualität für Ihre E-Mail-Kampagnen.",
									"linkText": "Bilder anzeigen",
									"introduction": "Es ist an der Zeit, Ihre Abonnenten über Ihre tollen Angebote und Rabatte für die Weihnachtszeit zu informieren. Laden Sie ein Bild herunter und fügen Sie es in die Kopfzeile Ihrer E-Mail-Kampagne oder E-Mail-Vorlage ein, um die größte Wirkung zu erzielen."
								},
								"social": {
									"title": "Soziale Medien",
									"subtitle": "Locken Sie mehr Kunden zur Weihnachtssaison mit diesen frei verwendbaren Bildern in Ihren Shop.",
									"linkText": "Posts anzeigen",
									"introduction": "Es ist an der Zeit, Ihre fantastischen Angebote und Rabatte für die Weihnachtszeit bekannt zu machen! Laden Sie einfach die Inhalte herunter und in Ihre Social-Media-Profile oder Ihr Terminplanungs-Tool hoch. Denken Sie daran, {link} auf Instagram zu markieren für mehr Käufer und mehr Umsatz."
								}
							},
							"imageAlt": {
								"holiday1": "Eine Frau in einem blau-rosa-silberfarbenen Bodysuit rutscht auf einem Knie zu einem Wischmopp; ein ausgestreckter Arm hält einen silbernen Schuh, der andere hält ein Smartphone.",
								"holiday2": "Ein Mann in einem bordeauxfarbenen Satin-Pyjama schwebt im Schneidersitz über einem Tischventilator, das Smartphone schwebt in Augenhöhe."
							}
						},
						"at-launch": {
							"title": "Beim Launch",
							"subtitle": "Haben Sie Ihre Reise mit uns gerade erst begonnen? Nutzen Sie diese Vorteile, um Ihren alten und neuen Kunden zu verkünden, dass Sie nun die Zahlung mit Klarna anbieten.",
							"channels": {
								"email": {
									"title": "E-Mail-Vorlagen",
									"subtitle": "Lassen Sie Ihre Abonnenten wissen, dass es an der Kasse eine neue Zahlungsmethode gibt.",
									"linkText": "Vorlagen anzeigen",
									"introduction": "Es ist an der Zeit, Ihren Abonnenten mitzuteilen, dass Sie mit Klarna durchstarten! Kopieren Sie einfach die Vorlage oder den Inhalt und fügen Sie ihn in Ihre E-Mail-Plattform ein, und schon können Sie loslegen.",
									"codeBoxTitle": "Launch E-Mail"
								},
								"social": {
									"title": "Soziale Medien",
									"subtitle": "Locken Sie mit diesen smooothen Bildern in Studioqualität mehr Kunden in Ihr Geschäft.",
									"linkText": "Posts anzeigen",
									"introduction": "Es ist an der Zeit, der Welt zu verkünden, dass Sie mit Klarna durchstarten! Laden Sie einfach die Assets herunter und in Ihre Social-Media-Profile oder Ihr Terminplanungs-Tool hoch. Denken Sie daran, in Ihren Ankündigungen {link} zu markieren, um noch mehr Käufer und Umsatz zu erreichen."
								},
								"osm": {
									"title": "Landing-Pages",
									"subtitle": "Kommen Sie Ihren Käufern entgegen und informieren Sie sie darüber, wie sie bei Klarna einkaufen können.",
									"linkText": "Seiten ansehen"
								}
							},
							"imageAlt": {
								"emotional": "Person mit langen, lockigen Haaren in lilafarbenem Jumpsuit, die an einem chromfarbenen Flipper spielt",
								"paymentShowcase": "Eine Hand hält ein Handy mit dem Klarna-Logo, im Hintergrund Rollschuhe",
								"simplified": "Handy mit dem Bildschirm nach unten auf einem chromfarbenen Flipper rechts, leuchtend gelbes Sofa links",
								"device": "Ins Bild baumelndes Handy mit dem Klarna-Logo, rosa Raum mit Kronleuchter im Hintergrund"
							}
						}
					}
				}
			}
		}
	}
};